import type { adminEn } from '@/i18n/resources/admin-en.ts';

type AdminResources = { [K in keyof typeof adminEn]: string };

export const adminNb = {
  'admin.common.retry': 'Prøv igjen',
  'admin.common.refresh': 'Oppdater',
  'admin.common.refreshing': 'Oppdaterer…',
  'admin.common.search': 'Søk',
  'admin.common.status': 'Status',
  'admin.common.name': 'Navn',
  'admin.common.unknown': 'Ukjent',
  'admin.common.anonymous': 'Anonym',
  'admin.common.cancel': 'Avbryt',
  'admin.common.enabled': 'Aktivert',
  'admin.common.disabled': 'Deaktivert',
  'admin.common.active': 'Aktiv',
  'admin.common.other': 'Annet',
  'admin.preview.title': 'Viser nettstedet som en {type}-konto',
  'admin.preview.body': 'Bare en forhåndsvisning av grensesnittet. Administratoridentiteten og servertillatelsene dine er uendret.',
  'admin.preview.exit': 'Avslutt forhåndsvisning',
  'admin.release.title': 'Versjonsmerknader',
  'admin.release.description': 'En oversikt over produksjonsversjoner og endringene i hver av dem.',
  'admin.release.loading': 'Laster versjonsmerknader',
  'admin.release.loadError': 'Kunne ikke laste versjonsmerknadene.',
  'admin.release.empty': 'Ingen versjoner er registrert ennå.',
  'admin.release.release': 'Versjon {version}',
  'admin.release.commits': '{count} innsjekking | {count} innsjekkinger',
  'admin.release.loadingOne': 'Laster versjon',
  'admin.release.loadOneError': 'Kunne ikke laste denne versjonen.',
  'admin.release.changesSince': 'Endringer siden versjon {version}',
  'admin.release.initialBaseline': 'Endringer siden det første utgangspunktet',
  'admin.release.summary': 'Sammendrag',
  'admin.release.fullCommits': 'Alle innsjekkingsmeldinger ({count})',
  'admin.release.noCommit': 'Denne versjonen inneholdt ingen ny kildekodeinnsjekking.',
  'admin.diagnostics.title': 'Diagnostikk',
  'admin.diagnostics.description': 'Sladdet nettleserdiagnostikk og databasefeil fra PocketBase.',
  'admin.diagnostics.loadError': 'Kunne ikke laste diagnostikken.',
  'admin.diagnostics.filter': 'Filtrer diagnostikk',
  'admin.diagnostics.messageRoute': 'Melding eller rute',
  'admin.diagnostics.level': 'Nivå',
  'admin.diagnostics.allLevels': 'Alle nivåer',
  'admin.diagnostics.error': 'Feil',
  'admin.diagnostics.warning': 'Advarsel',
  'admin.diagnostics.source': 'Kilde',
  'admin.diagnostics.allSources': 'Alle kilder',
  'admin.diagnostics.console': 'Konsoll',
  'admin.diagnostics.vue': 'Vue',
  'admin.diagnostics.router': 'Ruter',
  'admin.diagnostics.window': 'Vindu',
  'admin.diagnostics.database': 'Database',
  'admin.diagnostics.from': 'Fra',
  'admin.diagnostics.to': 'Til',
  'admin.diagnostics.applyFilters': 'Bruk filtre',
  'admin.diagnostics.loading': 'Laster diagnostikk…',
  'admin.diagnostics.empty': 'Ingen diagnostikk samsvarer med filtrene.',
  'admin.diagnostics.selectPage': 'Velg siden',
  'admin.diagnostics.selected': '{count} valgt',
  'admin.diagnostics.copySelected': 'Kopier valgte',
  'admin.diagnostics.clear': 'Tøm',
  'admin.diagnostics.selectOne': 'Velg diagnostikk: {message}',
  'admin.diagnostics.copyOne': 'Kopier diagnostikk: {message}',
  'admin.diagnostics.copy': 'Kopier',
  'admin.diagnostics.copiedOne': 'Diagnostikk kopiert',
  'admin.diagnostics.copiedMany': '{count} diagnostikkoppføringer kopiert',
  'admin.diagnostics.copyError': 'Kunne ikke kopiere. Kontroller nettleserens utklippstavletillatelse.',
  'admin.diagnostics.details': 'Diagnostikkdetaljer',
  'admin.diagnostics.unknownRoute': 'Ukjent rute',
  'admin.diagnostics.release': 'Versjon',
  'admin.diagnostics.environment': 'Miljø',
  'admin.diagnostics.fingerprint': 'Fingeravtrykk',
  'admin.diagnostics.user': 'Bruker',
  'admin.diagnostics.pages': 'Diagnostikksider',
  'admin.diagnostics.previous': 'Forrige',
  'admin.diagnostics.next': 'Neste',
  'admin.diagnostics.page': 'Side {page} av {pages} · {count} rapporter',
  'admin.diagnostics.reportHeading': 'Diagnostikk',
  'admin.diagnostics.reportsHeading': 'Diagnostikk ({count})',
  'admin.diagnostics.reported': 'Rapportert',
  'admin.diagnostics.route': 'Rute',
  'admin.diagnostics.id': 'ID',
  'admin.diagnostics.context': 'Kontekst',
  'admin.diagnostics.stack': 'Stakk',
  'admin.diagnostics.context.error': 'Feil',
  'admin.diagnostics.context.details': 'Detaljer',
  'admin.diagnostics.context.jobId': 'Jobb-ID',
  'admin.diagnostics.context.type': 'Type',
  'admin.diagnostics.context.method': 'Metode',
  'admin.diagnostics.context.status': 'Status',
  'admin.diagnostics.context.executionTime': 'Kjøretid',
  'admin.diagnostics.context.url': 'URL-sti',
  'admin.diagnostics.context.authCollection': 'Autentiseringssamling',
  'admin.diagnostics.context.authId': 'Autentiserings-ID',
  'admin.diagnostics.context.referer': 'Henvisende sti',
  'admin.diagnostics.context.userAgent': 'Brukeragent',
  'admin.pilot.eyebrow': 'Trygg lanseringsdrift',
  'admin.pilot.title': 'Drift av bedriftspiloter',
  'admin.pilot.description':
    'Test en bedriftsfunksjon med en liten gruppe verifiserte bedrifter før bredere lansering. Velg deltakere, styr tilgang, følg resultater og støttesaker, og fullfør, forbedre eller stans piloten.',
  'admin.pilot.authorizationNote': 'Funksjonsbrytere begrenser bare utrullingen. De erstatter aldri vanlige tilgangskontroller eller påkrevde Pro-rettigheter.',
  'admin.pilot.retry': 'Prøv igjen',
  'admin.pilot.emptyTitle': 'Ingen bedriftspiloter ennå',
  'admin.pilot.emptyDescription': 'Opprett et utkast for å definere mål, terskler, deltakere og vurderingsdato før en funksjon aktiveres.',
  'admin.pilot.createFirst': 'Opprett den første piloten',
  'admin.pilot.selectedPilot': 'Pilotområde',
  'admin.pilot.participants': 'Deltakere',
  'admin.pilot.enabledFlags': 'Aktive brytere',
  'admin.pilot.workspaceSections': 'Områder for bedriftspiloten',
  'admin.pilot.tab.overview': 'Oversikt',
  'admin.pilot.tab.rollout': 'Deltakere og utrulling',
  'admin.pilot.tab.support': 'Støtte',
  'admin.pilot.lifecycle': 'Pilotens livsløp',
  'admin.pilot.lifecycleHelp': 'Følg den kontrollerte veien fra oppsett til en registrert konklusjon.',
  'admin.pilot.step.setup': 'Sett opp',
  'admin.pilot.step.rollout': 'Rull ut',
  'admin.pilot.step.monitor': 'Følg med',
  'admin.pilot.step.decide': 'Avgjør',
  'admin.pilot.nextAction': 'Neste handling',
  'admin.pilot.next.create': 'Opprett et pilotutkast.',
  'admin.pilot.next.addBusiness': 'Legg til minst én verifisert bedrift i piloten.',
  'admin.pilot.next.configureFlag': 'Konfigurer en funksjonsbryter for piloten.',
  'admin.pilot.next.start': 'Kontroller oppsettet og start piloten.',
  'admin.pilot.next.resume': 'Kontroller forbedringene og gjenoppta piloten.',
  'admin.pilot.next.monitor': 'Følg produkthelse og støttebelastning frem til vurderingsdatoen.',
  'admin.pilot.next.complete': 'Piloten har en registrert konklusjon.',
  'admin.pilot.startRequirements': 'Oppstart krever minst én verifisert bedrift og én funksjonsbryter som tilhører piloten.',
  'admin.pilot.shutdownBlocked': 'Deaktiver alle aktive brytere for piloten før den stenges.',
  'admin.pilot.resume': 'Gjenoppta',
  'admin.pilot.details': 'Pilotdetaljer',
  'admin.pilot.owner': 'Administratoransvarlig',
  'admin.pilot.currentDecisionLabel': 'Registrert beslutning',
  'admin.pilot.checkoutCompletion': 'Fullførte betalinger',
  'admin.pilot.targetValue': 'Suksessmål {target} %',
  'admin.pilot.healthMetrics': 'Alle mål for produkthelse',
  'admin.pilot.metric.active_businesses': 'Aktive pilotbedrifter',
  'admin.pilot.metric.activated_businesses': 'Aktiverte bedrifter',
  'admin.pilot.metric.checkout_started': 'Påbegynte betalinger',
  'admin.pilot.metric.checkout_completed': 'Fullførte betalinger',
  'admin.pilot.metric.booking_attempts': 'Bestillingsforsøk',
  'admin.pilot.metric.booking_successes': 'Vellykkede bestillinger',
  'admin.pilot.metric.reconciliation_exceptions': 'Avstemmingsavvik',
  'admin.pilot.metric.open_support_cases': 'Åpne støttesaker',
  'admin.pilot.metric.resolved_support_cases': 'Løste støttesaker',
  'admin.pilot.metric.retained_businesses': 'Beholdte bedrifter',
  'admin.pilot.rosterHelp': 'Bare uttrykkelig valgte, verifiserte bedrifter får pilottilgang.',
  'admin.pilot.addBusiness': 'Legg til bedrift',
  'admin.pilot.rosterEmpty': 'Ingen bedrifter er registrert',
  'admin.pilot.rosterEmptyHelp': 'Legg til en verifisert bedrift før piloten startes.',
  'admin.pilot.actions': 'Handlinger',
  'admin.pilot.update': 'Oppdater',
  'admin.pilot.flagHelp': 'Brytere definerer funksjon, miljø, tidsrom og trygg reserveløsning for piloten.',
  'admin.pilot.configureFlag': 'Konfigurer bryter',
  'admin.pilot.flagsEmpty': 'Ingen pilotbrytere er konfigurert',
  'admin.pilot.flagsEmptyHelp': 'Opprett først en deaktivert bryter, kontroller reserveløsningen og aktiver den når piloten er klar.',
  'admin.pilot.disabled': 'Deaktivert',
  'admin.pilot.edit': 'Rediger',
  'admin.pilot.globalFlags': 'Globale utrullingsbrytere for bedrifter',
  'admin.pilot.globalFlagsHelp': 'Disse bryterne gjelder utenfor en bestemt pilot og vises separat for å unngå å knytte dem til valgt pilot.',
  'admin.pilot.supportScope':
    'Dette er den plattformomfattende støttekøen for bedrifter. Saker er ikke knyttet til valgt pilot med mindre bedriften står på pilotlisten.',
  'admin.pilot.supportEmpty': 'Ingen støttesaker for bedrifter',
  'admin.pilot.supportEmptyHelp': 'Nye personvernvennlige støttesaker vises her.',
  'admin.pilot.stateLabel': 'Tilstand',
  'admin.pilot.createHelp': 'Opprett rammene for en kontrollert test. Tilgang forblir avslått til utrullingen konfigureres separat.',
  'admin.pilot.keyHelp': 'Bruk bare små bokstaver, tall og understrek.',
  'admin.pilot.rosterDialogHelp': 'Bedriften må allerede være verifisert. Hver endring krever en revisjonsbegrunnelse.',
  'admin.pilot.businessSearchLabel': 'Verifisert bedrift',
  'admin.pilot.businessSearchPlaceholder': 'Søk etter bedriftsnavn, brukernavn, adresse eller ID',
  'admin.pilot.businessSearchHelp': 'Skriv minst to tegn, og velg deretter en verifisert bedrift fra resultatene.',
  'admin.pilot.businessSearching': 'Søker etter verifiserte bedrifter',
  'admin.pilot.businessSearchResults': 'Fant {count} verifiserte bedrifter',
  'admin.pilot.businessSearchEmpty': 'Ingen verifiserte bedrifter samsvarer med søket.',
  'admin.pilot.businessSearchError': 'Kunne ikke søke etter verifiserte bedrifter.',
  'admin.pilot.selectedBusiness': 'Valgt bedrift',
  'admin.pilot.changeBusiness': 'Bytt',
  'admin.pilot.flagDialogHelp': 'Lagring oppretter en ny loggført versjon for denne nøkkelen og dette miljøet.',
  'admin.pilot.confirmDecision': 'Bekreft pilothandling',
  'admin.pilot.decisionNotes': 'Beslutningsnotater',
  'admin.pilot.decisionNotesHelp': 'Registrer resultat, dokumentasjon og eventuelle oppfølgingsforpliktelser for denne endelige beslutningen.',
  'admin.pilot.consequence.pending': 'Dette endrer pilotens tilstand uten å registrere en endelig konklusjon.',
  'admin.pilot.consequence.iterate': 'Piloten settes på pause mens mangler, terskler eller utrulling forbedres.',
  'admin.pilot.consequence.graduate': 'Piloten avsluttes vellykket med fullføring registrert som konklusjon.',
  'admin.pilot.consequence.shutdown': 'Piloten avsluttes med nedstenging som konklusjon. Eksisterende kundeforpliktelser må fortsatt ivaretas.',
  'admin.pilot.supportPrivacyHelp':
    'Bruk bare nødvendige identifikatorer og sammendrag. Lim aldri inn kontaktopplysninger, legitimasjon, token, kortdata eller leverandørdata.',
  'admin.pilot.cancel': 'Avbryt',
  'admin.pilot.close': 'Lukk',
  'admin.pilot.save': 'Lagre endringer',
  'admin.pilot.confirm': 'Bekreft og loggfør',
  'admin.pilot.state.draft': 'Utkast',
  'admin.pilot.state.active': 'Aktiv',
  'admin.pilot.state.paused': 'Satt på pause',
  'admin.pilot.state.graduated': 'Fullført',
  'admin.pilot.state.shutdown': 'Stengt',
  'admin.pilot.state.invited': 'Invitert',
  'admin.pilot.state.exited': 'Avsluttet',
  'admin.pilot.state.development': 'Utvikling',
  'admin.pilot.state.staging': 'Testmiljø',
  'admin.pilot.state.production': 'Produksjon',
  'admin.pilot.state.low': 'Lav',
  'admin.pilot.state.normal': 'Normal',
  'admin.pilot.state.high': 'Høy',
  'admin.pilot.state.urgent': 'Haster',
  'admin.pilot.state.open': 'Åpen',
  'admin.pilot.state.investigating': 'Undersøkes',
  'admin.pilot.state.waiting': 'Venter',
  'admin.pilot.state.resolved': 'Løst',
  'admin.pilot.state.closed': 'Lukket',
  'admin.pilot.decision.pending': 'Avventer',
  'admin.pilot.decision.graduate': 'Fullfør',
  'admin.pilot.decision.iterate': 'Forbedre',
  'admin.pilot.decision.shutdown': 'Steng',
  'admin.pilot.loading': 'Laster pilotoperasjoner',
  'admin.pilot.operationFailed': 'Pilotoperasjonen mislyktes.',
  'admin.pilot.operationSuccess': 'Pilotoperasjonen er fullført og loggført.',
  'admin.pilot.create': 'Opprett pilot',
  'admin.pilot.key': 'Nøkkel',
  'admin.pilot.name': 'Navn',
  'admin.pilot.rationale': 'Begrunnelse',
  'admin.pilot.reviewDate': 'Vurderingsdato',
  'admin.pilot.successTarget': 'Mål for fullført betaling i %',
  'admin.pilot.shutdownBelow': 'Steng under %',
  'admin.pilot.createDraft': 'Opprett utkast',
  'admin.pilot.decision': 'Pilotbeslutning',
  'admin.pilot.pilot': 'Pilot',
  'admin.pilot.choose': 'Velg en pilot',
  'admin.pilot.ownerReview': 'Eier {owner} · vurdering {date}',
  'admin.pilot.currentDecision': 'Beslutning: {decision} {notes}',
  'admin.pilot.start': 'Start',
  'admin.pilot.pause': 'Sett på pause og forbedre',
  'admin.pilot.graduate': 'Fullfør',
  'admin.pilot.shutdown': 'Steng ned',
  'admin.pilot.decisionReason': 'Begrunnelse for denne loggførte pilotbeslutningen',
  'admin.pilot.decisionReasonHelp': 'Forklar hvorfor tilstandsendringen er nødvendig. Begrunnelsen lagres i det uforanderlige revisjonssporet.',
  'admin.pilot.recordDecision': 'Registrer beslutningen',
  'admin.pilot.flagRollout': 'Utrulling med funksjonsbryter',
  'admin.pilot.flagKey': 'Bryternøkkel',
  'admin.pilot.chooseFlag': 'Velg en funksjonsbryter',
  'admin.pilot.flagKeyHelp': 'Velg en funksjon fra samme katalog som brukes under Plattformadmin → Funksjonsbrytere.',
  'admin.pilot.environment': 'Miljø',
  'admin.pilot.environmentHelp': 'Velg hvor denne utrullingsversjonen gjelder. Produksjon styrer den publiserte opplevelsen.',
  'admin.pilot.cohort': 'Kohort',
  'admin.pilot.cohortHelp': 'Begrens til pilotlisten, eller bruk bryteren for alle bedrifter som ellers har tilgang.',
  'admin.pilot.verifiedRoster': 'Verifisert pilotliste',
  'admin.pilot.authorizedBusinesses': 'Alle autoriserte bedrifter',
  'admin.pilot.starts': 'Starter',
  'admin.pilot.startsHelp': 'Valgfritt. La feltet stå tomt for å gjøre versjonen tilgjengelig med én gang.',
  'admin.pilot.ends': 'Slutter',
  'admin.pilot.endsHelp': 'Valgfritt. Versjonen utløper automatisk på dette tidspunktet.',
  'admin.pilot.fallback': 'Feilsikker reserveløsning',
  'admin.pilot.fallbackPlaceholder': 'Deaktiver funksjonen og behold eksisterende forpliktelser',
  'admin.pilot.fallbackHelp': 'Beskriv trygg drift og hvilke forpliktelser som må bevares hvis bryteren deaktiveres eller rulles tilbake.',
  'admin.pilot.rationaleHelp': 'Forklar hvorfor denne utrullingsversjonen er nødvendig. Begrunnelsen lagres i revisjonshistorikken.',
  'admin.pilot.enabled': 'Aktivert',
  'admin.pilot.enabledHelp': 'Slå på serverevaluering for denne versjonen. La den være av mens utrullingen forberedes.',
  'admin.pilot.entitlement': 'Krever rettighet',
  'admin.pilot.entitlementHelp': 'Krev også den vanlige serverberegnede rettigheten. Bryteren kan aldri gi en slik rettighet.',
  'admin.pilot.pilotHelp': 'Velg hvilken pilotliste som bestemmer tilgang til funksjonen.',
  'admin.pilot.saveVersion': 'Lagre versjon',
  'admin.pilot.roster': 'Liste over verifiserte bedrifter',
  'admin.pilot.businessId': 'ID for verifisert bedrift',
  'admin.pilot.status': 'Status',
  'admin.pilot.reason': 'Begrunnelse',
  'admin.pilot.updateRoster': 'Oppdater listen',
  'admin.pilot.health': 'Personvernvennlig produkthelse',
  'admin.pilot.healthDescription': 'Bare samlede tall, siste 30 dager. Vurdering {date}.',
  'admin.pilot.openSupport': 'Opprett støttesak',
  'admin.pilot.optionalBusinessId': 'Bedrifts-ID (valgfritt)',
  'admin.pilot.supportBusinessHelp':
    'Søk etter navn, brukernavn, adresse eller ID. Velg bare den berørte verifiserte bedriften når det er nødvendig for å undersøke saken.',
  'admin.pilot.priority': 'Prioritet',
  'admin.pilot.priorityHelp': 'Bruk haster bare når normal drift eller kundeforpliktelser er i umiddelbar fare.',
  'admin.pilot.category': 'Kategori',
  'admin.pilot.categoryHelp': 'Bruk en kort driftskategori, for eksempel bestilling, betaling, tilgang eller avstemming.',
  'admin.pilot.relatedRecord': 'Tilknyttet oppføring',
  'admin.pilot.relatedRecordHelp': 'Knytt eventuelt til én intern oppføring med ugjennomsiktig ID. Ikke lim inn leverandørdata eller kundeopplysninger.',
  'admin.pilot.relatedRecordType': 'Oppføringstype',
  'admin.pilot.relatedRecordId': 'Oppførings-ID',
  'admin.pilot.opaqueId': 'Ugjennomsiktig ID',
  'admin.pilot.caseSummary': 'Kortfattet sakssammendrag',
  'admin.pilot.caseSummaryHelp': 'Beskriv problemet og driftsvirkningen med bare opplysningene som er nødvendige for støtte.',
  'admin.pilot.createReference': 'Opprett ugjennomsiktig referanse',
  'admin.pilot.supportQueue': 'Støttekø',
  'admin.pilot.reference': 'Referanse',
  'admin.pilot.case': 'Sak',
  'admin.pilot.state': 'Tilstand',
  'admin.pilot.changeState': 'Endre status for støttesaken',
  'admin.pilot.changeCaseReason': 'Begrunnelse for å endre støttesaken',
  'admin.pilot.resolution': 'Sammendrag av løsningen',
  'admin.pilot.currentFlags': 'Gjeldende bryterversjoner',
  'admin.pilot.flag': 'Bryter',
  'admin.pilot.window': 'Tidsrom',
  'admin.pilot.version': 'Versjon',
  'admin.pilot.now': 'nå',
  'admin.pilot.manualRollback': 'manuell tilbakestilling',
  'admin.seed.title': 'Demodata',
  'admin.seed.description':
    'Bygg gjenkjennelige demodata fra Oslo med målrettede oppsett. Hver genererte oppføring tilhører en kjøring, slik at den kan gjennomgås og fjernes senere.',
  'admin.seed.progress': 'Fremdrift for oppsett av demodata',
  'admin.seed.presets': 'Oppsett',
  'admin.seed.configure': 'Konfigurer',
  'admin.seed.review': 'Gjennomgå',
  'admin.seed.choosePresets': 'Velg scenariooppsett',
  'admin.seed.chooseHelp': 'Kombiner målrettede scenarioer, eller velg Alt-i-ett for en fullstendig demo. Minst ett oppsett er påkrevd.',
  'admin.seed.chooseRequired': 'Velg minst ett oppsett for å fortsette.',
  'admin.seed.configureRun': 'Konfigurer kjøringen',
  'admin.seed.defaults': 'Standardverdiene oppretter 3 grupper og 12 arrangementer i Oslo sentrum.',
  'admin.seed.runAndUser': 'Kjøring og hovedbruker',
  'admin.seed.runName': 'Navn på kjøringen',
  'admin.seed.generateUser': 'Generer en bruker',
  'admin.seed.generateUserHelp': 'Best for en isolert demo.',
  'admin.seed.existingUser': 'Bruk en eksisterende bruker',
  'admin.seed.existingUserHelp': 'Gjør denne kontoen til arrangør.',
  'admin.seed.generatedEmail': 'E-postgrunnlag for generering',
  'admin.seed.optional': '(valgfritt)',
  'admin.seed.generatedEmailHelp':
    'Bruk en innboks som godtar plussadresser for OTP-testing, eller la feltet stå tomt for trygge adresser som ikke kan motta e-post.',
  'admin.seed.existingUserId': 'Eksisterende bruker-ID',
  'admin.seed.recordIdPlaceholder': 'PocketBase-oppførings-ID',
  'admin.seed.contentOverrides': 'Innholdsoverstyringer',
  'admin.seed.resetDefaults': 'Tilbakestill til standardverdier',
  'admin.seed.groups': 'Grupper',
  'admin.seed.events': 'Arrangementer',
  'admin.seed.supportingUsers': 'Støttebrukere',
  'admin.seed.anchorDate': 'Forankringsdato',
  'admin.seed.timezone': 'Tidssone',
  'admin.seed.location': 'Sted',
  'admin.seed.latitude': 'Breddegrad',
  'admin.seed.longitude': 'Lengdegrad',
  'admin.seed.radius': 'Radius (km)',
  'admin.seed.reviewRun': 'Gjennomgå datakjøringen',
  'admin.seed.reviewHelp': 'Ingenting opprettes før du bekrefter nedenfor.',
  'admin.seed.primaryUser': 'Hovedbruker',
  'admin.seed.existingUserValue': 'Eksisterende bruker {id}',
  'admin.seed.generatedFrom': 'Generert fra «{email}»',
  'admin.seed.generatedAutomatically': 'Generert automatisk',
  'admin.seed.plannedContent': 'Planlagt innhold',
  'admin.seed.plannedContentValue': '{groups} grupper · {events} arrangementer · {users} støttebrukere',
  'admin.seed.placeTime': 'Sted og tid',
  'admin.seed.warning': 'Demodatakjøringer oppretter ekte oppføringer. Bruk dem bare til test- eller demodata, og fjern kjøringen når den ikke lenger trengs.',
  'admin.seed.back': 'Tilbake',
  'admin.seed.continue': 'Fortsett',
  'admin.seed.creating': 'Oppretter…',
  'admin.seed.create': 'Opprett demodata',
  'admin.seed.created': 'Demodata er opprettet.',
  'admin.seed.started': 'Datakjøringen er startet.',
  'admin.seed.startError': 'Kunne ikke starte datakjøringen.',
  'admin.seed.history': 'Kjøringshistorikk',
  'admin.seed.loadingRuns': 'Laster datakjøringer',
  'admin.seed.historyError': 'Kunne ikke laste kjøringshistorikken',
  'admin.seed.noRuns': 'Ingen datakjøringer ennå.',
  'admin.seed.resourcesCount': '{count} ressurser',
  'admin.seed.generatedUsersCount': '{count} genererte brukere',
  'admin.seed.viewDetails': 'Vis detaljer',
  'admin.seed.retryCleanup': 'Prøv opprydding igjen',
  'admin.seed.removeData': 'Fjern data',
  'admin.seed.runDetails': 'Kjøringsdetaljer',
  'admin.seed.closeDetails': 'Lukk kjøringsdetaljer',
  'admin.seed.loadingDetails': 'Laster kjøringsdetaljer',
  'admin.seed.loadDetailsError': 'Kunne ikke laste datakjøringen.',
  'admin.seed.resources': 'Ressurser',
  'admin.seed.generatedUsers': 'Genererte brukere',
  'admin.seed.email': 'E-post',
  'admin.seed.recordId': 'Oppførings-ID',
  'admin.seed.generatedResources': 'Genererte ressurser',
  'admin.seed.collection': 'Samling',
  'admin.seed.label': 'Etikett',
  'admin.seed.retryCleanupTitle': 'Prøve oppryddingen igjen?',
  'admin.seed.removeTitle': 'Fjerne denne datakjøringen?',
  'admin.seed.retryCleanupBody': 'Vennevent prøver igjen å fjerne de gjenværende oppføringene fra «{name}».',
  'admin.seed.removeBody': 'Alle oppføringer generert av «{name}» slettes. Eksisterende brukere og andre data inngår ikke i oppryddingen.',
  'admin.seed.removing': 'Fjerner…',
  'admin.seed.removeGenerated': 'Fjern genererte data',
  'admin.seed.cleanupPartial': 'Noen genererte oppføringer kunne ikke fjernes. Prøv oppryddingen igjen.',
  'admin.seed.removed': 'Demodata er fjernet.',
  'admin.seed.removeError': 'Kunne ikke fjerne de genererte oppføringene. Du kan trygt prøve igjen.',
  'admin.dashboard.title': 'Plattformadministrasjon',
  'admin.dashboard.description': 'Drift, tillit og kontoadministrasjon',
  'admin.dashboard.viewAs': 'Vis nettstedet som',
  'admin.dashboard.actualAccount': 'Faktisk konto ({type})',
  'admin.dashboard.personalAccount': 'Personlig konto',
  'admin.dashboard.businessAccount': 'Bedriftskonto',
  'admin.dashboard.previewHelp': 'Bare forhåndsvisning av grensesnittet; administratortilgangen forblir aktiv.',
  'admin.dashboard.moderation': 'Moderering',
  'admin.dashboard.sections': 'Administrasjonsområder',
  'admin.dashboard.loadError': 'Kunne ikke laste administrasjonsdata.',
  'admin.dashboard.actionSuccess': 'Administrasjonshandlingen er fullført.',
  'admin.dashboard.actionError': 'Administrasjonshandlingen mislyktes.',
  'admin.dashboard.reasonRequired': 'Begrunnelsen må inneholde minst tre tegn.',
  'admin.dashboard.tabs.overview': 'Oversikt',
  'admin.dashboard.tabs.overviewHelp': 'Plattformhelse og totaler',
  'admin.dashboard.tabs.configuration': 'Konfigurasjon',
  'admin.dashboard.tabs.configurationHelp': 'Adresser, leverandører og tjenester',
  'admin.dashboard.tabs.features': 'Funksjoner',
  'admin.dashboard.tabs.featuresHelp': 'Funksjonstilgjengelighet',
  'admin.dashboard.tabs.launch': 'Lanseringstrakt',
  'admin.dashboard.tabs.launchHelp': 'Aktivering av arrangører',
  'admin.dashboard.tabs.pilot': 'Bedriftspilot',
  'admin.dashboard.tabs.pilotHelp': 'Pilotprogram',
  'admin.dashboard.tabs.seed': 'Demodata',
  'admin.dashboard.tabs.seedHelp': 'Oppsett av testmiljø',
  'admin.dashboard.tabs.venues': 'Steder',
  'admin.dashboard.tabs.venuesHelp': 'Søknader og verifisering',
  'admin.dashboard.tabs.users': 'Brukere',
  'admin.dashboard.tabs.usersHelp': 'Kontoer og roller',
  'admin.dashboard.tabs.content': 'Innhold',
  'admin.dashboard.tabs.contentHelp': 'Arrangementer og grupper',
  'admin.dashboard.tabs.audit': 'Revisjon',
  'admin.dashboard.tabs.auditHelp': 'Administrasjonshistorikk',
  'admin.dashboard.tabs.diagnostics': 'Diagnostikk',
  'admin.dashboard.tabs.diagnosticsHelp': 'Nettleser- og databasefeil',
  'admin.dashboard.tabs.releases': 'Versjoner',
  'admin.dashboard.tabs.releasesHelp': 'Produksjonsendringer',
  'admin.dashboard.metrics.users': 'Brukere',
  'admin.dashboard.metrics.events': 'Arrangementer',
  'admin.dashboard.metrics.groups': 'Grupper',
  'admin.dashboard.metrics.verifiedVenues': 'Verifiserte steder',
  'admin.dashboard.metrics.pendingVenues': 'Ventende steder',
  'admin.dashboard.metrics.openReports': 'Åpne rapporter',
  'admin.dashboard.last30Days': 'Siste 30 dager',
  'admin.dashboard.date': 'Dato',
  'admin.dashboard.activationTitle': 'Arrangøraktivering · siste {days} dager',
  'admin.dashboard.activationHelp': 'Overordnede førsteparts traktdata. Rå lanseringshendelser beholdes i 180 dager.',
  'admin.dashboard.fromPrevious': '{percent}% fra forrige',
  'admin.dashboard.acquisitionCohorts': 'Anskaffelseskohorter',
  'admin.dashboard.source': 'Kilde',
  'admin.dashboard.campaign': 'Kampanje',
  'admin.dashboard.organizers': 'Arrangører',
  'admin.dashboard.activated': 'Aktiverte',
  'admin.dashboard.retainedGroups': 'Beholdte grupper',
  'admin.dashboard.featureFlags': 'Funksjonsbrytere',
  'admin.dashboard.featureHelp': 'Endringer gjelder globalt. Deaktiverte brytere stenger tilgangen for alle brukere.',
  'admin.dashboard.enable': 'Aktiver',
  'admin.dashboard.disable': 'Deaktiver',
  'admin.dashboard.flagConfirm': '{action} {name} globalt? Dette gjelder også plattformadministratorer.',
  'admin.dashboard.flagReason': 'Begrunnelse for å {action} {name}',
  'admin.dashboard.allStatuses': 'Alle statuser',
  'admin.dashboard.pending': 'Venter',
  'admin.dashboard.approved': 'Godkjent',
  'admin.dashboard.rejected': 'Avslått',
  'admin.dashboard.allStates': 'Alle tilstander',
  'admin.dashboard.restricted': 'Begrenset',
  'admin.dashboard.business': 'Bedrift',
  'admin.dashboard.address': 'Adresse',
  'admin.dashboard.category': 'Kategori',
  'admin.dashboard.proof': 'Dokumentasjon',
  'admin.dashboard.preview': 'Forhåndsvis',
  'admin.dashboard.approve': 'Godkjenn',
  'admin.dashboard.reject': 'Avslå',
  'admin.dashboard.approvalReason': 'Intern begrunnelse for godkjenning',
  'admin.dashboard.rejectionReason': 'Avslagsmerknad til søkeren',
  'admin.dashboard.popupError': 'Tillat sprettoppvinduer for å forhåndsvise dokumentasjonen.',
  'admin.dashboard.proofError': 'Kunne ikke åpne dokumentasjonen.',
  'admin.dashboard.user': 'Bruker',
  'admin.dashboard.state': 'Tilstand',
  'admin.dashboard.role': 'Rolle',
  'admin.dashboard.venue': 'Sted',
  'admin.dashboard.verified': 'Verifisert',
  'admin.dashboard.unverified': 'Ikke verifisert',
  'admin.dashboard.restore': 'Gjenopprett',
  'admin.dashboard.suspend': 'Suspender',
  'admin.dashboard.revokeModerator': 'Fjern moderator',
  'admin.dashboard.makeModerator': 'Gjør til moderator',
  'admin.dashboard.changeEmail': 'Endre e-post',
  'admin.dashboard.resetPassword': 'Tilbakestill passord',
  'admin.dashboard.revokeVerification': 'Trekk tilbake verifisering',
  'admin.dashboard.restoreVerification': 'Gjenopprett verifisering',
  'admin.dashboard.newEmail': 'Ny e-postadresse',
  'admin.dashboard.confirmEmail': 'Skriv CHANGE EMAIL for å bekrefte',
  'admin.dashboard.changeEmailReason': 'Begrunnelse for e-postendringen',
  'admin.dashboard.passwordReason': 'Begrunnelse for å sende passordtilbakestilling',
  'admin.dashboard.userStatusReason': 'Begrunnelse for å {action} kontoen',
  'admin.dashboard.userRoleReason': 'Begrunnelse for å sette rollen til {role}',
  'admin.dashboard.verificationReason': 'Begrunnelse for å {action} stedsverifiseringen',
  'admin.dashboard.owner': 'Eier',
  'admin.dashboard.restrict': 'Begrens',
  'admin.dashboard.contentReason': 'Begrunnelse for å {action} denne {type}',
  'admin.dashboard.when': 'Når',
  'admin.dashboard.action': 'Handling',
  'admin.dashboard.target': 'Mål',
  'admin.dashboard.reason': 'Begrunnelse',
  'admin.dashboard.actor': 'Aktør',
  'admin.pilot.development': 'Utvikling',
  'admin.pilot.staging': 'Testmiljø',
  'admin.pilot.production': 'Produksjon',
  'admin.pilot.invited': 'Invitert',
  'admin.pilot.active': 'Aktiv',
  'admin.pilot.paused': 'Satt på pause',
  'admin.pilot.exited': 'Avsluttet',
  'admin.pilot.low': 'Lav',
  'admin.pilot.normal': 'Normal',
  'admin.pilot.high': 'Høy',
  'admin.pilot.urgent': 'Haster',
  'admin.pilot.none': 'Ingen',
  'admin.pilot.booking': 'Bestilling',
  'admin.pilot.payment': 'Betaling',
  'admin.pilot.subscription': 'Abonnement',
  'admin.pilot.reconciliation': 'Avstemming',
  'admin.pilot.open': 'Åpen',
  'admin.pilot.investigating': 'Undersøkes',
  'admin.pilot.waiting': 'Venter',
  'admin.pilot.resolved': 'Løst',
  'admin.pilot.closed': 'Lukket',
  'admin.seed.defaultName': 'Demodata fra Oslo',
} satisfies AdminResources;
